import { Add } from "@material-ui/icons"

import { MasterButton } from "App/Component/ui"

import React, { useState, useContext, useEffect } from "react"
import { FormContext } from "../../context/FormContext"
import { TableTabPenjualan } from "../TabPenjualan/TabPenjualan"
import { ModalListPenjualan } from "./helpers"
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers"

import { instance3 } from "App/constants"

function TabExternal({ setNewData, rows, rowsKunjungan }) {
  const [showModalListPenjualan, setShowModalListPenjualan] = useState(false)
  const { formData, setFormData } = useContext(FormContext)

  useEffect(() => {
    setNewData()
  }, [formData.tagihan_id]) // eslint-disable-line react-hooks/exhaustive-deps

  const clickDelete = async (row) => {
    try {
      const api = await instance3.post("/poolExternal/delete", {
        id: row.pollExtId,
        tagihanId: formData.tagihan_id,
      })

      if (api.data.status === 200) {
        setFormData({
          ...formData,
          reload_final_jasmed: !formData.reload_final_jasmed,
        })
        defaultToastSuccess("Berhasil menghapus penjualan dari tagihan ini")
        await setNewData()
      } else {
        defaultToastError(api.data.message)
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message)
    }
  }

  return (
    <>
      {showModalListPenjualan && (
        <ModalListPenjualan
          setNewData={setNewData}
          setShowModal={setShowModalListPenjualan}
        />
      )}

      {formData.status === 0 && rowsKunjungan.length === 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
          }}
        >
          <MasterButton
            type={"button"}
            color="green"
            outline={true}
            onClick={() => {
              if (isNull(formData.tagihan_id)) {
                defaultToastError("Buka tagihan terlebih dahulu")
              } else {
                setShowModalListPenjualan(!showModalListPenjualan)
              }
            }}
            name="Tambah Penjualan External"
            size="sm"
            withIcon={true}
            icon={
              <Add
                width="15px"
                height="15px"
                style={{
                  marginLeft: "-0.5rem",
                }}
              />
            }
          />
        </div>
      )}

      <TableTabPenjualan
        rows={rows}
        clickDelete={clickDelete}
        inTabExternal={true}
      />
    </>
  )
}

export default TabExternal
